import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MemberRechargePositionEdit',
  data: function data() {
    return {
      title: '',
      form: {
        rechargePositionId: null,
        position: null,
        monthNum: null,
        account: null,
        remarksOne: null,
        remarksTwo: null,
        favorablePrice: null,
        giveMonthNum: null
      },
      rules: {
        position: [{
          required: true,
          message: '请输入档位',
          trigger: 'blur'
        }],
        favorablePrice: [{
          required: true,
          message: '请输入优惠价',
          trigger: 'blur'
        }],
        monthNum: [{
          required: true,
          message: '请输入月数',
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: '请输入金额',
          trigger: 'blur'
        }],
        giveMonthNum: [{
          required: true,
          message: '请输入赠送月数',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.rechargePositionId = null;
      this.form.position = null;
      this.form.monthNum = null;
      this.form.account = null;
      this.form.remarksOne = null;
      this.form.remarksTwo = null;
      this.form.favorablePrice = null;
      this.form.giveMonthNum = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.rechargePositionId = data.rechargePositionId;
      this.form.position = data.position;
      this.form.monthNum = data.monthNum;
      this.form.account = data.account;
      this.form.remarksOne = data.remarksOne;
      this.form.remarksTwo = data.remarksTwo;
      this.form.favorablePrice = data.favorablePrice;
      this.form.giveMonthNum = data.giveMonthNum;
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_MEMBERRECHARGEPOSITION(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_MEMBERRECHARGEPOSITION(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.rechargePositionId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};